/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  NodoIconaDto,
  NodoIconaCreateDto,
  NodoIconaUpdateDto,
} from ".././models";

export const getNodoIcone = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoIconaDto[]>> => {
  return axios.get(`/api/nodo_icone`, options);
};

export const getGetNodoIconeQueryKey = () => [`/api/nodo_icone`] as const;

export const getGetNodoIconeQueryOptions = <
  TData = Awaited<ReturnType<typeof getNodoIcone>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNodoIcone>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<Awaited<ReturnType<typeof getNodoIcone>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodoIconeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodoIcone>>> = ({
    signal,
  }) => getNodoIcone({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetNodoIconeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNodoIcone>>
>;
export type GetNodoIconeQueryError = AxiosError<unknown>;

export const useGetNodoIcone = <
  TData = Awaited<ReturnType<typeof getNodoIcone>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNodoIcone>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNodoIconeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createNodoIcona = (
  nodoIconaCreateDto: NodoIconaCreateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoIconaDto>> => {
  return axios.post(`/api/nodo_icone`, nodoIconaCreateDto, options);
};

export const getCreateNodoIconaMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNodoIcona>>,
    TError,
    { data: NodoIconaCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNodoIcona>>,
  TError,
  { data: NodoIconaCreateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNodoIcona>>,
    { data: NodoIconaCreateDto }
  > = (props) => {
    const { data } = props ?? {};

    return createNodoIcona(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNodoIconaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNodoIcona>>
>;
export type CreateNodoIconaMutationBody = NodoIconaCreateDto;
export type CreateNodoIconaMutationError = AxiosError<unknown>;

export const useCreateNodoIcona = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNodoIcona>>,
    TError,
    { data: NodoIconaCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getCreateNodoIconaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateNodoIcona = (
  id: number,
  nodoIconaUpdateDto: NodoIconaUpdateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoIconaDto>> => {
  return axios.put(`/api/nodo_icone/${id}`, nodoIconaUpdateDto, options);
};

export const getUpdateNodoIconaMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNodoIcona>>,
    TError,
    { id: number; data: NodoIconaUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNodoIcona>>,
  TError,
  { id: number; data: NodoIconaUpdateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNodoIcona>>,
    { id: number; data: NodoIconaUpdateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNodoIcona(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNodoIconaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNodoIcona>>
>;
export type UpdateNodoIconaMutationBody = NodoIconaUpdateDto;
export type UpdateNodoIconaMutationError = AxiosError<unknown>;

export const useUpdateNodoIcona = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNodoIcona>>,
    TError,
    { id: number; data: NodoIconaUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateNodoIconaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteNodoIcona = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/api/nodo_icone/${id}`, options);
};

export const getDeleteNodoIconaMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNodoIcona>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNodoIcona>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNodoIcona>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNodoIcona(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNodoIconaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNodoIcona>>
>;

export type DeleteNodoIconaMutationError = AxiosError<unknown>;

export const useDeleteNodoIcona = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNodoIcona>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getDeleteNodoIconaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getNodoIconaImage = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(`/api/nodo_icone/${id}/img`, options);
};

export const getGetNodoIconaImageQueryKey = (id: number) =>
  [`/api/nodo_icone/${id}/img`] as const;

export const getGetNodoIconaImageQueryOptions = <
  TData = Awaited<ReturnType<typeof getNodoIconaImage>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNodoIconaImage>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getNodoIconaImage>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodoIconaImageQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNodoIconaImage>>
  > = ({ signal }) => getNodoIconaImage(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetNodoIconaImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNodoIconaImage>>
>;
export type GetNodoIconaImageQueryError = AxiosError<unknown>;

export const useGetNodoIconaImage = <
  TData = Awaited<ReturnType<typeof getNodoIconaImage>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNodoIconaImage>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNodoIconaImageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetNodoIcone = () =>
  //@ts-ignore
  useGetNodoIcone(...([] as any[]));

export const __$$useCreateNodoIcona = () =>
  //@ts-ignore
  useCreateNodoIcona(...([] as any[]));

export const __$$useUpdateNodoIcona = () =>
  //@ts-ignore
  useUpdateNodoIcona(...([] as any[]));

export const __$$useDeleteNodoIcona = () =>
  //@ts-ignore
  useDeleteNodoIcona(...([] as any[]));

export const __$$useGetNodoIconaImage = () =>
  //@ts-ignore
  useGetNodoIconaImage(...([] as any[]));
